<script lang="ts">
    import type { SystemStatus } from '../stores/status';

    export let status: SystemStatus = 'ok';
    export let large: boolean = false;
</script>

<span
    class="status-dot status-dot--{status}"
    class:status-dot--large={large}
    role="status"
    aria-label="System status: {status}"
>
    {#if status === 'error'}
        <span class="ping"></span>
    {/if}
</span>

<style lang="scss">
    .status-dot {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        flex-shrink: 0;
        transition: background-color 0.3s ease, box-shadow 0.3s ease;

        &--large {
            width: 16px;
            height: 16px;
        }

        &--ok {
            background-color: $color-status-ok;
            box-shadow: 0 0 5px rgba($color-status-ok, 0.6);
        }

        &--warning {
            background-color: $color-status-warning;
            box-shadow: 0 0 5px rgba($color-status-warning, 0.6);
            animation: dot-breathe 2.5s ease-in-out infinite;
        }

        &--error {
            background-color: $color-status-error;
            box-shadow: 0 0 8px rgba($color-status-error, 0.9);
            animation: dot-pulse 0.8s ease-in-out infinite;
        }
    }

    .ping {
        position: absolute;
        inset: 0;
        border-radius: 50%;
        background-color: $color-status-error;
        animation: dot-ping 1.2s ease-out infinite;
        pointer-events: none;
    }

    @keyframes dot-breathe {
        0%, 100% { box-shadow: 0 0 3px rgba($color-status-warning, 0.4); }
        50%       { box-shadow: 0 0 10px rgba($color-status-warning, 1); }
    }

    @keyframes dot-ping {
        0%   { transform: scale(1);   opacity: 0.7; }
        100% { transform: scale(3);   opacity: 0; }
    }

    @keyframes dot-pulse {
        0%, 100% { opacity: 1; }
        50%       { opacity: 0.4; }
    }
</style>
